import listEmbeddableMixin from "@/mixins/embeddable/resource/listEmbeddableMixin";
import StockProductEmbeddable from "@/views/modules/stock/StockProduct/embeddable/StockProductEmbeddable";


export default {
    components:{StockProductEmbeddable},
    mixins: [listEmbeddableMixin],
    data() {
        return {
            path: "production/order", //Override somente de front-end, por tanto irá utilizar o mesmo path que o original da página 56
        }

    },
    async mounted() {

        /*Declarar todos os campos no padrão que podem ser utilizados*/

        const formDefault = {
            default: "", //NÃO ESQUECER DOS CAMPOS PADROES DE BUSCA COMO DEFAULT E STATUS (caso existir)
            productId: 0,
            groupProductId: 0,
            modelId: 0,
            unitId: 0,
            stockPlaceProductInsideId: 0
        }

        this.form = Object.assign({}, formDefault,this.form);
    },
    methods:{

    }
}